import { ProjectViewModel } from "../../../../ViewModel/ProjectViewModel";
import { PdsrClientViewModel } from "../../../../ViewModel/PdsrClientViewModel";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";

export function setSameEngineeredSFOnSamePdsrOnEveryRoute(
  project: ProjectViewModel,
  editPdsr: PdsrClientViewModel,
  value: number
) {
  const updatedRoutes: Array<string | undefined> = [];
  const ftlWithNewShipFrequency = project.FTLRoutes?.map((ftlRoute: FtlRouteViewModel) => {
    if (!ftlRoute.PdsrsOnThisRoute) {
      return ftlRoute;
    }

    return {
      ...ftlRoute,
      PdsrsOnThisRoute: ftlRoute.PdsrsOnThisRoute.map((pdsr: PdsrClientViewModel) => {
        if (pdsr.PdsrId === editPdsr.PdsrId) {
          updatedRoutes.push(ftlRoute.RouteNumber);
          return {
            ...pdsr,
            ShipFrequency: value,
          };
        }
        return pdsr;
      }),
    };
  });
  return { updatedRoutes, ftlWithNewShipFrequency };
}
